import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async create(datos) {
    return await axiosIns.post(obtenerUrlAPIComisiones('requisitos-documentales'), datos);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('requisitos-documentales'), opciones);
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`requisitos-documentales/${id}`));
  },
  async update(id, datos) {
    return await axiosIns.patch(obtenerUrlAPIComisiones(`requisitos-documentales/${id}`), datos);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIComisiones(`requisitos-documentales/${id}`));
  },
  async findByInstitucion(institucionId) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`requisitos-documentales/instituciones/${institucionId}`));
  },
};
